import gsap from 'gsap';
import { getCurrentDevice } from '../utils';

export class FlipCard {
	constructor( selector, options = {} ) {
		this.container = document.querySelector( selector );
		this.options = options;
		this.devices = options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ];
		this.direction =
			this.options.direction === 'vertical' ? 'rotationY' : 'rotationX';
		this.reverse = this.options.reverse ? -1 : 1;
		this.isEnable = false;
		this.currentDevice = getCurrentDevice();
		this.front = null;
		this.back = null;
		this.enterFunc = null;
		this.leaveFunc = null;
		this.back = null;
		this.tween = null;
		this.timer = null;
		this.init();
	}

	init() {
		if ( this._initBound ) return;
		this._initBound = true;
		if ( ! this.container ) return;
		window.addEventListener( 'DOMContentLoaded', () => {
			this.execute();
		} );
		this.resize();
	}

	execute() {
		this.front = this.container.querySelector( '.el-front' );
		this.back = this.container.querySelector( '.el-back' );
		gsap.set( this.container, {
			transformStyle: 'preserve-3d',
			transformPerspective: 1000,
		} );
		gsap.set( this.back, { [ this.direction ]: 180 * this.reverse } );
		const tlVars = { paused: true };
		if ( this.options.delay ) tlVars.delay = this.options.delay;
		this.tween = gsap
			.timeline( tlVars )
			.to( this.front, {
				duration: this.options.duration || 0.5,
				ease: this.options.ease || 'power1.inOut',
				[ this.direction ]: -180 * this.reverse,
			} )
			.to(
				this.back,
				{
					duration: this.options.duration || 0.5,
					ease: this.options.ease || 'power1.inOut',
					[ this.direction ]: 0,
				},
				0
			);
		this.enterFunc = () => this.enter();
		this.leaveFunc = () => this.leave();
		this.container.addEventListener( 'mouseenter', this.enterFunc );
		this.container.addEventListener( 'mouseleave', this.leaveFunc );
		this.isEnable = true;
	}

	kill() {
		gsap.set( [ this.container, this.front, this.back ], {
			clearProps: 'all',
		} );
		this.container.removeEventListener( 'mouseenter', this.enterFunc );
		this.container.removeEventListener( 'mouseleave', this.leaveFunc );
		this.tween = null;
		this.isEnable = false;
	}

	resize() {
		window.addEventListener( 'resize', () => {
			this.timer?.kill();
			this.timer = gsap.delayedCall( 0.5, () => {
				const prevDevice = this.currentDevice;
				this.currentDevice = getCurrentDevice();
				if ( prevDevice !== this.currentDevice ) {
					if ( this.isEnable ) {
						this.kill();
					}
					if ( this.devices.includes( this.currentDevice ) ) {
						this.execute();
					}
				}
			} );
		} );
	}

	enter() {
		this.tween.play();
	}

	leave() {
		this.tween.reverse();
	}
}
